export const transformStringPath = (str: string): string[] => {
    return str.replace(/\[(\d+)\]/g, '.$1').split('.');
};
